<template>
  <section class="page">
    <div class="scroll-wrap" :class="{ 'flex-1': !isFocus }">
      <section class="top">
        <img
          class="top-img"
          src="https://coupe-static.xiaolachuxing.com/image/3abece620430dc6949dc269b1b8b279d9a037493.png"
          alt=""
        />
        <div class="top-title">取消成功</div>
        <div class="top-desc">实际支付金额将原路退回</div>
      </section>
      <section class="content">
        <section class="content-top">
          <div class="content-top-title">您为什么要取消？</div>
          <div class="content-top-desc">请告知取消原因，我们将努力改善</div>
        </section>
        <van-collapse
          class="content-collapse"
          v-model="collapseActiveItem"
          accordion
          :border="hasBorder"
        >
          <van-collapse-item
            v-for="(item, index) in reasonList"
            :key="index"
            :title="item.levelOneReason"
            :name="index"
            :border="hasBorder"
          >
            <div class="content-collapse__item">
              <div
                v-for="subItem in item.levelTwoReasonInfo"
                :key="subItem.id"
                class="content-collapse__item-row"
                @click="selectedReason(subItem)"
              >
                <div class="flex-center flex-justify-between">
                  <div class="content-collapse__item-row-txt">
                    {{ subItem.reason }}
                  </div>
                  <template v-if="activeId == subItem.id">
                    <img
                      class="content-collapse__item-row-icon"
                      src="@/assets/images/checked.png"
                      alt=""
                    />
                  </template>
                  <img
                    v-else
                    class="content-collapse__item-row-icon"
                    src="https://coupe-static.xiaolachuxing.com/image/cf21844b801a500fd70f43e8fe724553901b7cf5.png"
                    alt=""
                  />
                </div>
                <div
                  v-if="isShowBlockDriver && activeId == subItem.id"
                  class="content-collapse__item-row-tip"
                >
                  {{ rowTip }}
                </div>
              </div>
            </div>
          </van-collapse-item>

          <van-collapse-item title="其它" name="custom" :border="hasBorder">
            <textarea
              v-if="isShowTextarea"
              class="content-collapse__textarea"
              placeholder="如有其它取消原因，请在这里告诉我们"
              maxlength="120"
              v-model="inputReasonText"
              rows="4"
              :autofocus="isAutofocus"
              @input="onInput"
              @focus="handleFocus"
              @blur="handleBlur"
            >
            </textarea>
          </van-collapse-item>
        </van-collapse>
      </section>
    </div>

    <section class="bottom" :class="{ 'safe-bottom': !isFocus }">
      <div class="bottom-wrap">
        <xl-button
          size="xlarge"
          type="dark"
          block
          :class="{ disabled: !canSubmit }"
          class="bottom-btn"
          @click="submit"
          >提交原因</xl-button
        >
        <div v-if="isShowBlockDriver" class="block-driver">
          <div
            v-if="!isBlock"
            class="block-driver__text flex-center"
            @click="blockDriver"
          >
            不想让该快送员抢我的订单
            <img
              class="block-driver__arrow"
              src="@/assets/images/ic_right@2x.png"
              alt=""
            />
          </div>
          <div v-else class="block-driver__text flex-center">
            已拉黑，平台将不会推送你的订单给该快送员
          </div>
        </div>
      </div>
    </section>

    <!-- 用来获取屏幕高度值，防止APP和小程序取值不一致 -->
    <div id="screenDiv"></div>
  </section>
</template>

<script>
import {
  fetchCancelOrderReasonList,
  fetchSubmitCancelOrderReason,
} from '@/api/modules/cancel';
import {
  fetchOrderDetails,
  fetchCarInfo,
  fetchBlockDriver,
} from '@/api/modules/order';
import { isMiniProgram, mpPostMessage } from '@/utils/base';

export default {
  data() {
    return {
      orderId: '',
      orderStatus: '',
      orderUuid: '',
      reasonList: [],
      activeId: '',
      reasonDesc: '',
      orderFrom: '',
      inputReasonText: '', // 自定义取消原因
      collapseActiveItem: 0,
      hasBorder: false,
      isMp: false,
      isFocus: false,
      isAutofocus: true,
      driverReasonIndex: -1,
      isSelectDriverReason: false, // 选中的单选框是否为“快送员原因”这一栏
      isSetBlock: false,
      orderData: {},
      ratedInfo: {},
      carInfo: {},
      rowTip: '平台将核实快送员问题，若快送员有责将严肃处理',
    };
  },
  created() {
    this.orderId = this.$route.query.order_id;
    this.orderStatus = this.$route.query.order_status;
    this.orderUuid = this.$route.query.order_uuid;
    this.orderFrom = this.$route.query.order_from;
    if (this.orderId && this.orderStatus) {
      this.getReasonList();
      this.getOrderDetail();
    } else {
      this.$toast('缺少订单相关参数');
    }

    this.isMp = isMiniProgram();
  },
  mounted() {
    // 埋点，取消订单成功_曝光
    this.$sa.track('cancel_order_success_expo', {
      order_uuid: this.orderUuid,
    });

    this.isMp && mpPostMessage({ handler: 'cancelReasonSubmitted' });
  },
  computed: {
    canSubmit() {
      return this.inputReasonText || this.activeId;
    },
    isShowTextarea() {
      return this.collapseActiveItem === 'custom';
    },
    // 拉黑快送员确认框文案
    comfirmCtx() {
      return (
        this?.ratedInfo?.blacklistMessage ||
        '快送员加入黑名单后，3个月内平台将不会推送你的订单给该快送员'
      );
    },
    // 是否显示拉黑快送员入口（选中的单选框为快送员原因 且 当前是在快送员原因list）
    isShowBlockDriver() {
      return (
        this.isSelectDriverReason &&
        this.driverReasonIndex === this.collapseActiveItem
      );
    },
    // 是否已拉黑快送员
    isBlock() {
      return Boolean(this?.ratedInfo?.isBlacklist) || this.isSetBlock;
    },
  },
  methods: {
    handleFocus() {
      this.isFocus = true;
      setTimeout(() => {
        window.scrollTo(0, 9999);
        let bottomWrapEl = document.querySelector('.bottom-wrap');
        let clientHeight = document.querySelector('#screenDiv').offsetTop;
        let h =
          clientHeight - (bottomWrapEl.offsetHeight + bottomWrapEl.offsetTop);
        setTimeout(() => window.scrollBy(0, 0 - h), 100);
      }, 400);
    },
    handleBlur() {
      this.isFocus = false;
    },
    async getReasonList() {
      const { data } = await fetchCancelOrderReasonList();
      this.reasonList = (data?.list || []).filter(
        (item) =>
          item?.levelTwoReasonInfo && item?.levelTwoReasonInfo?.length > 0,
      );

      // 快送单，直接前端处理改成快送员

      this.reasonList = this.reasonList.map((item) => {
        return {
          ...item,
          levelOneReason: item.levelOneReason.replace(/司机/g, '快送员'),
        };
      });

      this.driverReasonIndex = this.reasonList.findIndex(
        (item) => item.levelOneReason === '快送员原因',
      );

      if (this.reasonList.length === 0) {
        this.isAutofocus = false; // 只有单独的“其它”一项时，第一次进来不要聚焦
        this.collapseActiveItem = 'custom';
        setTimeout(() => (this.isAutofocus = true), 0);
      }
    },
    async getOrderDetail() {
      const { data = {} } = await fetchOrderDetails({
        orderId: this.orderId,
        orderUuid: this.orderUuid,
        needFeeDetail: 0,
      });
      this.orderData = data;
      this.ratedInfo = data?.ratingComment || {};
    },
    async getCarInfo() {
      const { data = {} } = await fetchCarInfo({
        param: {
          drierId: this.orderData.driverId,
          vehicleId: this.orderData.vehicleId,
          orderUuid: this.orderData.orderUuid || this.orderId,
        },
      });
      this.carInfo = data;
    },
    selectedReason(item) {
      if (this.activeId === item.id) {
        return this.clearReason();
      }
      this.activeId = item.id;
      this.reasonDesc = item.reason;
      this.inputReasonText = '';
      this.isSelectDriverReason =
        this.driverReasonIndex === this.collapseActiveItem;
    },
    clearReason() {
      this.activeId = '';
      this.reasonDesc = '';
      this.isSelectDriverReason = false;
    },
    onInput(e) {
      e.target.value && this.clearReason();
    },
    async submit() {
      if (!this.canSubmit) {
        this.$toast({
          message: '请选择原因',
          forbidClick: true,
          duration: 1000,
        });
        return;
      }

      // 埋点，取消订单成功_确认
      this.$sa.track('cancel_order_success_confirm', {
        order_uuid: this.orderUuid,
        cancel_reason: this.inputReasonText || this.reasonDesc,
      });

      await fetchSubmitCancelOrderReason({
        orderId: this.orderId,
        orderStatus: this.orderStatus,
        reasonCode: 70, // 固定传70
        reason: this.inputReasonText || this.reasonDesc,
      });

      this.$toast.success({
        message: '提交成功',
        forbidClick: true,
        onClose: () => {
          window.history.go(-1);
        },
      });
    },
    blockDriver() {
      this.$sa.track('block_driver_click', {
        order_uuid: this.orderUuid,
        module_name: '不想让该快送员抢我的订单',
        page_name: '取消订单',
      });
      this.$sa.track('block_confirm_popup_expo', {
        order_uuid: this.orderUuid,
        page_name: '取消订单',
      });
      // this.$confirm({
      //   title: '将快送员加入黑名单',
      //   message: this.comfirmCtx,
      // })
      //   .then(() => {
      //     this.comfirmConfirm();
      //   })
      //   .catch(() => {
      //     this.comfirmCancel();
      //   });

      this.$dialog
        .confirm({
          title: '将快送员加入黑名单',
          message: this.comfirmCtx,
          confirmButtonType: 'primary',
        })
        .then(() => {
          this.comfirmConfirm();
        })
        .catch(() => {
          this.comfirmCancel();
        });
    },
    comfirmCancel() {
      this.$sa.track('block_confirm_popup_click', {
        order_uuid: this.orderUuid,
        module_name: '取消',
        page_name: '取消订单',
      });
    },
    async comfirmConfirm() {
      this.$sa.track('block_confirm_popup_click', {
        order_uuid: this.orderUuid,
        module_name: '确认',
        page_name: '取消订单',
      });
      this.$loading.show();

      await this.getCarInfo();
      await fetchBlockDriver({
        driverFid: this.carInfo?.driverFid,
        orderId: this.orderId,
        scene: 1,
      }).catch((error) => {
        this.$toast({
          message: error.message || 'error',
          forbidClick: true,
        });
        this.$loading.hide();
        throw 'fetchBlockDriver error';
      });

      this.$loading.hide();
      this.isSetBlock = true;

      this.$toast.success({
        message: '已加入黑名单',
        forbidClick: true,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/styles/variables.less';
.page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
}
.scroll-wrap {
  overflow-y: scroll;
  padding-bottom: 12px;
}
.top {
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .top-img {
    width: 48px;
    height: 48px;
  }
  .top-title {
    margin-top: 12px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #222;
  }
  .top-desc {
    opacity: 0.8;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    color: #666;
  }
}
.content {
  margin: 0 12px;
  padding: 16px 12px 0 12px;
  box-sizing: border-box;
  border-radius: 14px;
  background-color: #fff;
  .content-top {
    margin-bottom: 16px;
    padding: 0 4px;
    .content-top-title {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    .content-top-desc {
      margin-top: 4px;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #666;
    }
  }
  .content-collapse {
    // 魔改一下 vant 折叠面板的样式
    .van-collapse-item {
      /deep/ &__content {
        padding: 0;
        font-size: 0;
      }
      /deep/ .van-cell {
        padding: 15px 9px 15px 4px;
        align-items: center;
        &__title {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
        }
        &__right-icon {
          height: 16px;
          line-height: 16px;
        }
      }
      /deep/ .van-cell:active {
        background-color: transparent;
      }
    }

    &__item {
      background: #f7f8fb;
      border-radius: 8px;
      padding: 4px 8px 4px 12px;
      &-row {
        padding: 12px 0;
        &-txt {
          height: 17px;
          line-height: 17px;
          font-size: 12px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #222222;
        }
        &-icon {
          width: 16px;
          height: 16px;
        }
        &-tip {
          min-height: 17px;
          line-height: 17px;
          font-size: 12px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          margin: 2px 0 -8px 0;
        }
      }
    }

    &__textarea {
      width: 100%;
      height: 76px;
      resize: none;
      background: rgba(244, 244, 244, 0.6);
      border-radius: 8px;
      padding: 8px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      box-sizing: border-box;
      margin-bottom: 16px;
      color: black;
    }
  }
}

.bottom {
  background-color: #fff;
  &-wrap {
    padding: 12px;
    box-sizing: border-box;
    .block-driver {
      &__text {
        height: 17px;
        line-height: 17px;
        margin-top: 16px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
      &__arrow {
        width: 17px;
        height: 17px;
        transform: translateY(-0.5px);
      }
    }
    .bottom-btn {
      font-family: @font-family;
      font-weight: 500;
    }
  }
}

#screenDiv {
  position: fixed;
  bottom: 0;
}
</style>
